import styled from 'styled-components';

/**
 * The main editing area of a content editor modal, beside the sidebar.
 * It draws the line between the two; the frame around the pair belongs to
 * EditorModalLayout. Each editor adds only its own inner layout.
 */
export const EditorMainContent = styled.div`
  flex: 1;
  min-width: 0;
  overflow: auto;
  padding: var(--medium-big-padding);
  background: var(--beige-main);
  border-right: 1px solid var(--gray-dark);
`;
